export default "__VITE_ASSET__CrlcMvn0__"